import React, { Component } from 'react'
import { Route, Switch } from "react-router-dom"

import Faq from './Faq'
import PriceDetail from './PriceDetail'
import TermsOfUse from './TermsOfUse'
import CheckUserPage from './CheckUserPage'

class StaticPages extends Component {
	render() {
		return (
				<Switch>
					<Route exact path="/faq" component={Faq}/> 
					<Route exact path="/price-detail" component={PriceDetail}/>
					<Route exact path="/terms-of-use" component={TermsOfUse}/>
					<Route path="/update" component={CheckUserPage}/>
				</Switch>
		)
	}
}

export default StaticPages
